/**
 * RESPONSIBILITY: the home page's opening band.
 *
 * What plays behind the title is the media's job; this lays the title, tagline and buttons
 * over it. The words stay on screen throughout - nothing fades them for a video.
 */
import type { HomeHeroSection } from '@app/sections';
import { HeroMedia } from './HeroMedia';

export function HomeHero({ c }: { c: HomeHeroSection }) {
  return (
    <section className="hero">
      <HeroMedia mode={c.mode} image={c.image} stills={c.stills} groups={c.groups} video={c.video} />
      <div className="hero-scrim" />
      <div className="hero-inner">
        <div className="hero-content">
          {c.eyebrow && <p className="hero-eyebrow">{c.eyebrow}</p>}
          {c.title && <h1>{c.title}</h1>}
          {c.tagline && <p className="hero-tagline">{c.tagline}</p>}
          {c.showButtons !== false && (c.ctaLabel || c.altLabel) && (
            <div className="btns">
              {c.ctaLabel && <a className="btn btn-light" href={c.ctaHref || '#'}>{c.ctaLabel}</a>}
              {c.altLabel && <a className="btn btn-ghost-light" href={c.altHref || '#'}>{c.altLabel}</a>}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
